<!--
 * @Description: 时间起止
 * @Date: 2025-07-14 15:43:15
-->
<template>
  <BaseFormItem
    :label="`${label}起`"
    :prop="startProp"
    :rules="[
      {
        required: true,
        trigger: 'change',
        message: '请选择'
      }
    ]"
  >
    <BaseDatePicker
      style="width: 100%; flex: none"
      type="date"
      placeholder="请选择"
      :validate-event="true"
      :disabled-date="startDisabledDate"
      @change="onStartChange"
      v-model="startValue"
    />
  </BaseFormItem>
  <BaseFormItem
    :label="`${label}止`"
    :prop="endProp"
    :rules="[
      {
        required: true,
        trigger: 'change',
        message: '请选择'
      }
    ]"
  >
    <div style="display: flex; align-items: center; width: 100%">
      <BaseDatePicker
        style="flex: 1"
        type="date"
        placeholder="请选择"
        :clearable="false"
        :disabled="isLongterm"
        :validate-event="true"
        :disabled-date="endDisabledDate"
        @change="onEndChange"
        v-model="endValue"
      />
      <BaseCheckbox
        style="margin-left: 12px"
        v-model="isLongterm"
        @change="onLongChange"
      >
        长期有效
      </BaseCheckbox>
    </div>
  </BaseFormItem>
</template>

<script lang="ts" setup>
import { ref, withDefaults, defineProps, defineModel, watchEffect } from 'vue';
import { BaseFormItem, BaseDatePicker, BaseCheckbox } from 'xrk-components';
import { formatter } from '@/utils';

withDefaults(
  defineProps<{
    label: string;
    startProp: string;
    endProp: string;
    // style type rules都写死了，有需要再扩展
  }>(),
  {
    label: '时间'
  }
);

const isLongterm = ref(false);
const startValue = defineModel<string>('start');
const endValue = defineModel<string>('end');

watchEffect(() => {
  isLongterm.value = endValue.value === '长期';
});

const startDisabledDate = e => {
  // 可选时间不能大于结束时间，结束时间为长期时不限制。
  return endValue.value && endValue.value !== '长期'
    ? new Date(endValue.value).getTime() <
        new Date(formatter.date(e, 'YYYY-MM-DD')).getTime()
    : false;
};
const endDisabledDate = e => {
  // 可选时间不能小于开始时间。
  return startValue.value
    ? new Date(startValue.value).getTime() >
        new Date(formatter.date(e, 'YYYY-MM-DD')).getTime()
    : false;
};
const onLongChange = e => {
  endValue.value = e ? '长期' : '';
};
const onStartChange = e => {
  console.log(e);
};
const onEndChange = e => {
  console.log(e);
};
</script>
